import React from 'react';
import Icon from '../icons/Icon';

const EventIcon = ({ type }) => {
  switch (type) {
    case 'goal':   return <Icon name="goal" size={20} className="ev-goal" />;
    case 'yellow': return <Icon name="yellowCard" size={18} strokeWidth={0} />;
    case 'red':    return <Icon name="redCard" size={18} strokeWidth={0} />;
    case 'sub':    return <Icon name="sub" size={18} className="ev-sub" />;
    case 'var':    return <Icon name="var" size={18} />;
    default:       return null;
  }
};

const eventLabel = (e) => {
  if (e.type === 'goal') return `Goal — ${e.player}${e.assist ? ` (assist: ${e.assist})` : ''}`;
  if (e.type === 'yellow') return `Yellow card — ${e.player}`;
  if (e.type === 'red') return `Red card — ${e.player}`;
  if (e.type === 'sub') return `Substitution: ${e.playerOff} ↔ ${e.playerOn}`;
  return e.player || '';
};

export default function EventsTab({ match }) {
  const events = match.events || [];

  if (events.length === 0) {
    return (
      <div className="tab-empty">
        <p>No events yet.</p>
        <p className="tab-empty-sub">Match hasn't started or no events recorded.</p>
      </div>
    );
  }

  return (
    <div className="events-timeline">
      {events.map((e, i) => (
        <div key={i} className={`event-row ${e.team}`}>
          {e.team === 'home' ? (
            <>
              <div className="event-side home-side">
                <span className="event-icon"><EventIcon type={e.type} /></span>
                <span className="event-label">{eventLabel(e)}</span>
              </div>
              <div className="event-minute">{e.minute}'</div>
              <div className="event-side away-side empty"></div>
            </>
          ) : (
            <>
              <div className="event-side home-side empty"></div>
              <div className="event-minute">{e.minute}'</div>
              <div className="event-side away-side">
                <span className="event-icon"><EventIcon type={e.type} /></span>
                <span className="event-label">{eventLabel(e)}</span>
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
}
